import * as React from 'react';
import TextField from '../TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { fetchCountryCodes } from 'store/actions/commonComponentActions';
import { useSelector, useDispatch } from 'react-redux'
import { Typography, Box } from '@mui/material';

const CountryCode = ({ required, handleOptionChange, defaultValue }) => {
    const dispatch = useDispatch();
    const filter = createFilterOptions();
    const commonReducer = useSelector(state => state.commonReducer);
    const { countryCodes } = commonReducer;
    const handleInputChange = (e) => {
        if (e) {
            const { value } = e.target;
            value && fetchCountryCodes(dispatch, { search: value })
        } else {
            fetchCountryCodes(dispatch, { search: defaultValue })
        }
    }
    const handleSelection = (option) => {
        handleOptionChange(option)
    }
    return (
        <Autocomplete
            disablePortal
            ListboxProps={{
                sx: {
                    padding: '8px',
                    //   marginTop: '10px',
                    boxshadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
                    borderRadius: '5px',
                }
            }}
            value={defaultValue}
            options={countryCodes}
            renderOption={(props, countryCodes) => (
                <Box component="li" {...props} key={countryCodes.id} borderRadius='5px'>
                    <Box color='#66668f'>{countryCodes}</Box>
                </Box>
            )}
            renderInput={(params) => <TextField {...params} required={required} bgwhite label={"Country"}
                InputLabelProps={{ shrink: false }} className='customInput bootstrapLabel' />}
            fullWidth
            className='customInput'
            size='small'
            onInputChange={handleInputChange}
            filterOptions={(options, params) => {
                const filtered = filter(options, params)
                const { inputValue } = params
                // Suggest the creation of a new value
                const isExisting = options.some(option => inputValue === option)
                if (inputValue !== '' && !isExisting && inputValue.length === 3) {
                    filtered.push(`Add ${inputValue}`)
                }
                return filtered
            }}
            onChange={(event, newValue) => {
                if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    handleSelection(newValue.replace('Add ', ''))
                } else {
                    handleSelection(newValue ? newValue.replace('Add ', '') : newValue)
                }
            }
            }
            noOptionsText={<Typography variant='h6' style={{ fontFamily: 'poppins', fontWeight: 'bold', fontSize: '12px' }}>Please enter a valid 3 letter country code</Typography>}
        />
    );
}

export default CountryCode;
